import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, type SxProps, type Theme } from '@mui/material';
import { AlertCard } from '@trendiolive/trendio-selfcare-ui-kit';

import { ALERT_BUTTON_PROPS_BY_SEVERITY, ALERT_CARD_DEFAULT_SX } from 'constants/ui-constants';
import type { AlertCardSeverity } from 'model/types/alert-card';

// ==============================|| SEVERITY BASED ALERT CARD ||============================== //

export type CtaProps = { buttonCta: string; buttonOnClick: () => void } | { buttonCta?: never; buttonOnClick?: never };

type SeverityBasedAlertCardProps = Readonly<
  {
    title: string;
    description?: string;
    severity: AlertCardSeverity;
    sx?: SxProps<Theme>;
    children?: ReactNode;
  } & CtaProps
>;

export default function SeverityBasedAlertCard({
  title,
  description,
  severity,
  buttonCta,
  buttonOnClick,
  sx = ALERT_CARD_DEFAULT_SX,
  children
}: SeverityBasedAlertCardProps) {
  const action =
    severity !== 'success' && buttonCta && buttonOnClick ? (
      <Button {...ALERT_BUTTON_PROPS_BY_SEVERITY[severity]} onClick={buttonOnClick}>
        <FormattedMessage id={buttonCta} />
      </Button>
    ) : undefined;

  return (
    <AlertCard title={title} description={description} severity={severity} sx={sx} action={action}>
      {children}
    </AlertCard>
  );
}
